<template>
  <div>
    <b-col cols="12">
      <p>{{labelTitle}}</p>
    </b-col>

    <b-row
      v-for="file in this.attachFiles"
      :key="file.attachId"
      class="col-12 m-1"
    >
      <b-col md="5">
        <a :href="file.filePath" :download="file.fileName" target="_blank">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-arrow-down-circle"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="8 12 12 16 16 12" />
            <line x1="12" y1="8" x2="12" y2="16" />
          </svg>
          {{ file.fileName }}
        </a>
      </b-col>
      <b-col md="5">
        <span>{{ file.masterDescription }}</span>
      </b-col>
      <b-col md="2" class="d-flex justify-content-center">
        <a
          href="javascript:void(0)"
          class="text-danger"
          @click="onAttachFileDelete(file.attachId)"
        >
          <feather-icon icon="Trash2Icon" size="24" />
        </a>
      </b-col>
    </b-row>

    <b-col cols="12" md="6">
      <b-form-group>
        <b-form-select v-model="selected" :options="attachTypes" />
      </b-form-group>
    </b-col>

    <b-col cols="12" md="6">
      <b-form-group>
        <b-form-file
          @change="onUploadFileChanged"
          ref="file-input"
          multiple
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>
    </b-col>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BFormFile,
} from "bootstrap-vue";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import * as storeMaster from "@/store/api/master/index.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
    extend,
  },
  props: {
    attachFiles: [],
    labelTitle: '',
    isClue: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      attachTypes: [],
      selected: 13,
    };
  },
  created() {
    if (this.isClue === true) {  
      this.getClueFileType();
    } else {
      this.getFileType();
    }   
  },
  methods: {
    getFileType() {
      const _this = this;
      storeMaster
        .getMasterByType()
        .then(function(response) {
          // handle success
          //console.log('then', response);

          var convertData = response.data.data.map(function(item, index) {
            return {
              value: item.masterId,
              text: item.description,
            };
          });

          _this.attachTypes = convertData;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onUploadFileChanged(e) {
      const selectedFiles = e.target.files;
      if (selectedFiles === null || selectedFiles === undefined || selectedFiles.length <= 0) {
        return;
      }

      const _this = this;
      var isMissing = this.onValidateExtensionFiles(selectedFiles, null);
      if (isMissing === true) {
        return;
      }

      selectedFiles.forEach(function(value, index) {
        _this.createBase64Image(value);
      });
    },
    createBase64Image(fileObject) {
      const _this = this;
      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        this.$refs["file-input"].reset();

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            fileType: _this.selected,
            masterId: _this.selected,
          },
        ];
        storeFileUpload
          .uploadFile(data)
          .then(function(response) {
            // handle success
            // console.log(response);
            response.data.data.forEach(function(value, index) {
              //console.log('emit upload', value)
              //this.$emit('handleSend', id)
              _this.emitUploadFile(value);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
          });
        //console.log('base64', base64)
      };

      reader.readAsDataURL(fileObject);
    },
    emitUploadFile(file) {
      let attachs = this.attachFiles
      attachs.push(file)
      this.$emit("handleChanged", attachs);
      //this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      console.log('onDeleteFile', id)

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      let attachs = filteredAry;
      this.$emit("handleChanged", attachs);
    },
    getClueFileType() {
      const _this = this;
      storeMaster
        .getClueMasterByType()
        .then(function(response) {
          // handle success
          //console.log('then', response);

          var convertData = response.data.data.map(function(item, index) {
            return {
              value: item.masterId,
              text: item.description,
            };
          });

          _this.attachTypes = convertData;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onValidateExtensionFiles(selectedFiles, section) {
      console.log(`onvalidateextensionfiles.section`, section);
      let isMissing = false;

      // เช็คว่าไฟล์ที่อัพโหลดมีสกุลไฟล์หรือไม่
      // ถ้าไม่มีให้แสดง popup แจ้งเตือน
      const arrNoExtension = Object.values(selectedFiles).filter((file) => {
        return (
          file.type === null || file.type === undefined || file.type === ""
        );
      });

      if (arrNoExtension.length > 0) {
        isMissing = true;
        this.$swal({
          html:
            "<div>ไม่สามารถอัพโหลดไฟล์ที่ไม่มีสกุลไฟล์ได้<br />กรุณาตรวจสอบไฟล์ของท่านก่อนทำการอัพโหลด</div>",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          try {
            this.$refs["file-input"].reset();
          } catch (ex) {
            console.log(ex);
          }
        });
      }

      return isMissing;
    },
  },
};
</script>

<style></style>
